<template>
    <VTour :steps="steps" :callbacks="callbacks" :button-labels="buttonLabels" highlight ref="tour" @onTourStart="callbackOnTourStart" />
</template>

<script>

import {Listeners} from "../../constants/listeners";
import {getCookie, isCookieEnabled, setCookie} from "tiny-cookie";
import moment from "moment";
// import

// зависимости наименований слушателя события старта и наименования куки
const COOKIE_NAMES_RELATIONS = {
    [Listeners.CLUSTER_TOUR_START]: 'keys.so_clusterTour',
};

export default {
    name: "AdaptersTour",
    emits: ['onTourStart'],
    data() {
        return {
            // Начиная с версии Chrome M104 (август 2022 г.), файлы cookie больше не могут устанавливать срок действия более чем на 400 дней в будущем.
            cookieExpiresYears: 10,
            showTourDelayInMs: 300,
            buttonLabels: {
                next: this.$t('lang.main.tour.next'),
                prev: this.$t('lang.main.tour.previous'),
                finish: this.$t('lang.main.tour.stop'),
                skip: this.$t('lang.main.tour.close'),
            },
        }
    },
    props: {
        steps: {
            type: Array,
            required: true,
        },
        listenerIdStart: {
            type: String,
            required: true,
        },
        callbackOnTourStart: {
            type: Function,
            required: false,
            default: null
        },
        callbacks: {
            type: Object,
            required: false,
        },
    },
    mounted() {
        this.$emitter.on(this.listenerIdStart, () => {
            // для отображения тура необходимо очищать локальное хранилище
            this.$refs.tour.resetTour();
            this.$refs.tour.startTour();
        });
        this.checkFirstShowTour();
    },
    computed: {
        getCookieName() {
            return COOKIE_NAMES_RELATIONS[this.listenerIdStart];
        },
    },
    methods: {
        checkFirstShowTour() {
            if (isCookieEnabled() && !getCookie(this.getCookieName)){
                setTimeout(() => {
                    this.$refs.tour.startTour();
                    setCookie(
                        this.getCookieName,
                        1,
                        {expires: moment().add(this.cookieExpiresYears, 'y').toISOString()}
                    );
                }, this.showTourDelayInMs);
            }
        },
    }
}
</script>

<style scoped>
#vjt-tooltip {
    background-color: #50596C;
    z-index: 100000;
    padding: 1rem;
}
:deep(#vjt-arrow)::before {
    background-color: #50596C;
}
:deep(.vjt-actions) {
    margin-top: 1.5rem;
}
:deep(.vjt-actions) button:hover {
    background-color: #33404D;
}
:deep(.vjt-actions) button {
    padding: .5rem;
}
#vjt-tooltip:deep(code) {
    background-color: #454d5d;
    padding: 2px;
}
#vjt-tooltip:deep(.tour__header) {
    margin: -1rem -1rem 1rem;
    background-color: #454d5d;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    text-align: center;
}
#vjt-tooltip:deep(ul) {
    list-style: none;
}
#vjt-tooltip:deep(li):not(:last-of-type) {
    margin-bottom: .5rem;
    font-size: .75rem;
}
</style>

<style>
.vjt-highlight {
  z-index: 100000;
  position: relative;
  outline-color: #50596C;
}
</style>
